import i18n from  "./../../Documental/Localization/i18n.js";
import CodingSystemTranslator from "./../../Documental/View/CodingSystemTranslator.js";


/**
 * Helper for formatting results and representation in app
 * 
 */

class ResultParser {
  
  requestGroupResource:any = null;
  codingTranslator = new CodingSystemTranslator();

  /**
   * 
   * 
   * @return RequestGroup resource
   * @return void
  */
  loadByRequestGroupResource( resource:any ) {
    if( resource === null || !resource ){
      return;
    }

    this.requestGroupResource = resource;
  }

  
  /**
   * Main result / decision
   * 
   * @returns object
   */
  getDecision(){

    let mainResult = {
      "resolvedFromResource" : false,

      "code" : "",
      "system" : "",
      "display" : "",

      "finalSuggestion" : "", // consultation  ||  all-good
      "finalServiceProvider" : "", // psychiatrist or psychologist
      "finalSuggestionTitle" : "",
      "finalSuggestionText" : "",

      "serviceRequestId" : "",
      "bookingServiceId" : "" // simplebook.me service ID discovered
    }

    if( this.requestGroupResource === null || !this.requestGroupResource ){
      return mainResult;
    }

    let resourceJson = this.requestGroupResource.toObject();
    mainResult.resolvedFromResource = true;
    
    for( var i in resourceJson.action ){
      let actionJson = resourceJson.action[ i ];
      if(
        typeof actionJson.extension === 'undefined' || 
        typeof actionJson.extension[ 0 ] === 'undefined'
      ){
        if(
            typeof actionJson.code !== 'undefined' && 
            typeof actionJson.code[ 0 ] !== 'undefined' && 
            typeof actionJson.code[ 0 ].coding !== 'undefined' && 
            typeof actionJson.code[ 0 ].coding[ 0 ] !== 'undefined' && 
            typeof actionJson.code[ 0 ].coding[ 0 ].code !== 'undefined'
        ){
          mainResult.code = actionJson.code[ 0 ].coding[ 0 ].code;
          mainResult.system = actionJson.code[ 0 ].coding[ 0 ].system;
          mainResult.display = actionJson.code[ 0 ].coding[ 0 ].display;

          mainResult.serviceRequestId = actionJson.resource.reference.split("ServiceRequest/").join("");
          
          if( mainResult.code && mainResult.system ){
            let t = this.codingTranslator.getTranslatedDisplayForCodeAndCurentLanguage( mainResult.system, mainResult.code );
            if( t ){
              mainResult.display = t;
            }
          }
        }
      }
      
    }

    mainResult.finalSuggestionTitle = mainResult.display;
    
    if( 
      mainResult.code === "" ||
      mainResult.code === "GR" ||
      mainResult.code === 'GY' 
    ){
      mainResult.finalSuggestion = 'all-good';
      mainResult.finalSuggestionTitle = i18n.t("In our opinion, you do not need a consultation with a mental health professional.");
      mainResult.finalSuggestionText = "";
    } else {
      mainResult.finalSuggestion = 'consultation';
      mainResult.finalSuggestionText = i18n.t("We offer the opportunity for a free video consultation. You will find more information after starting the process of booking");
      if( mainResult.code === "PT" || mainResult.code === "GP" ){
        mainResult.finalServiceProvider = 'psychologist';
        mainResult.finalSuggestionTitle = i18n.t("We recommend a consultation with a psychologist");
      } else {
        mainResult.finalServiceProvider = 'psychiatrist'; // PS ja ER
        mainResult.finalSuggestionTitle = i18n.t("We recommend a consultation with a psychiatrist");
      }
    }

    return mainResult;
  }


  getMatrixItems(){

    if( this.requestGroupResource === null || !this.requestGroupResource ){
      return;
    }

    let resourceJson = this.requestGroupResource.toObject();
    let resultsActions:any  =  [];

    for( var i in resourceJson.action ){
      let item = this.createMatrixItemFromAction( resourceJson.action[ i ] );
      if( item !== null ){
        resultsActions.push( item );
      }
    }

    return resultsActions;

  }


  getMatrixBaseRecord() {
    let obj = {
      "letter" : "",
      "topic" : "",
      "problemSystem" : "",
      "problemCode" : "",
      "problemDisplay" : "",
      "content" : "Insufficient data for evaluation",
      "priority" : "",
      "priorityColor" : "",
      "priorityColorNr" : 0,
      "useHTMLcolor" : "#C4C4C4"
    }
    return obj;
  }

  
  createMatrixItemFromAction( actionJson:any ): Object | null {
    let obj = this.getMatrixBaseRecord();

    if(
      typeof actionJson.extension === 'undefined' || 
      typeof actionJson.extension[ 0 ] === 'undefined'
    ){
      return null;
    }
    
    if(
      typeof actionJson.extension[ 0 ].url === 'undefined' || 
      actionJson.extension[ 0 ].url !== "http://documental.ee/fhir/extension/request-group/action/problem" 
    ){
      return null;
    }
    
    if(
      typeof actionJson.extension[ 0 ].valueCodeableConcept !== 'undefined'
    ){
      obj.problemSystem = actionJson.extension[ 0 ].valueCodeableConcept.coding[ 0 ].system;
      obj.problemCode   = actionJson.extension[ 0 ].valueCodeableConcept.coding[ 0 ].code;
      if( typeof actionJson.extension[ 0 ].valueCodeableConcept.coding[ 0 ].display != 'undefined' ){
        obj.problemDisplay   = actionJson.extension[ 0 ].valueCodeableConcept.coding[ 0 ].display;
      }
    }

    obj.topic = obj.problemDisplay;

    /** 
     * // Use translation file - not resource
    if( obj.problemCode && obj.problemSystem ){
      let t = codingTranslator.getTranslatedDisplayForCodeAndCurentLanguage( obj.problemSystem, obj.problemCode );
      if( t ){
        obj.topic = t;
        obj.problemDisplay = t;
      }
    }
    */

    let testShort = i18n.t( obj.topic + "_short" ); // use original english for short too
    obj.topic = i18n.t( obj.topic );

    obj.topic = obj.topic.charAt(0).toUpperCase() + obj.topic.slice(1);
    obj.letter = obj.topic.substr( 0, 2 );

    if( testShort.indexOf( "_short" ) < 0 ){
      obj.letter = testShort;
    }
    
    if( typeof actionJson.priority !== 'undefined' ){
      obj.priority = actionJson.priority;
      
      if( obj.priority === 'routine' ){
        obj.priorityColor = 'green';
        obj.useHTMLcolor = "#9AD506";
        obj.priorityColorNr = 1;
        obj.content = i18n.t("No deviations detected");
      }
      
      if( obj.priority === 'urgent' ){
        obj.priorityColor = 'yellow';
        obj.useHTMLcolor ="#ffdd6d";
        obj.priorityColorNr = 2;
        obj.content = i18n.t("Moderate deviations");
      }

      if( obj.priority === 'asap' ){
        obj.priorityColor = 'orange';
        obj.useHTMLcolor ="#F46F21";
        obj.priorityColorNr = 3;
        obj.content = i18n.t("Significant deviations");
      }

      if( obj.priority === 'stat' ){
        obj.priorityColor = 'orange';
        obj.useHTMLcolor ="#F46F21";
        obj.priorityColorNr = 4;
        obj.content = i18n.t("Significant deviations");
      }
    } else {
      // seems that priority value is now missing. Use code.coding[0].code instead?
      // or default to 
      /*
      
        GY(2, "Not enough data for triage", RequestPriority.NULL), 

        GR(3, "No action is suggested", RequestPriority.ROUTINE),

        GP(1, "General practitioner consultancy is recommended", RequestPriority.URGENT),
        PT(4, "Psychotherapy is recommended", RequestPriority.URGENT),
        PS(5, "Psychiatric consultation is recommended", RequestPriority.ASAP),
        ER(6, "Emergency care is recommended", RequestPriority.STAT);

        Et siis UA olukorras peaks ER ja PS minema kokku oranžiks "asap" tasemeks soovitusega minna 
        psühhiaatrile .. 
        
        GP ja PT lähevad kokku kollaseks "urgent" tasemeks soovitusega minna psühholoogile. 

        GY jääb halliks. GR jääb roheliseks "routine" tasemeks... Eestis oleks ER jäänud punaseks "stat"
        tasemeks soovitusega minna erakorralisse vastuvõttu. Kas nii? 
      let resultCode = '';
      if(
        typeof actionJson.code !== 'undefined' && 
        typeof actionJson.code[ 0 ] !== 'undefined' && 
        typeof actionJson.code[ 0 ].coding !== 'undefined' && 
        typeof actionJson.code[ 0 ].coding[ 0 ] !== 'undefined' && 
        typeof actionJson.code[ 0 ].coding[ 0 ].code !== 'undefined'
      ){
        resultCode = actionJson.code[ 0 ].coding[ 0 ].code;
      }
      
      if( resultCode === 'GR' ){
        obj.priority = 'routine';
        obj.priorityColor = 'green';
        obj.priorityColorNr = 1;
        obj.content = i18n.t("No deviations detected");
      }
      
      if( resultCode === 'GP' || resultCode === 'PT' ){
        obj.priority = 'urgent';
        obj.priorityColor = 'yellow';
        obj.priorityColorNr = 2;
        obj.content = i18n.t("Moderate deviations");
      }

      if( resultCode === 'ER' || resultCode === 'PS' ){
        obj.priority = 'stat';
        obj.priorityColor = 'orange';
        obj.priorityColorNr = 4;
        obj.content = i18n.t("Significant deviations");
      } 
      */
    }
    
    
    return obj;
  }


  /**
   * Use same colors as in CSS
   * Group topics 
   * 
   * @returns 
   */
  getMatrixTopicsGroupedForPdf( matrixItems:any ) {
    let groups:any = [];

    if( typeof matrixItems === 'undefined' || matrixItems === null ){
      matrixItems = this.getMatrixItems();
    }
    
    groups.push( {
      "priority" : "routine",
      "priorityColor" : "grey",
      "useHTMLcolor" : "#C4C4C4",
      "priorityColorNrs" : [ 0 ],
      "content" : i18n.t("Insufficient data for evaluation"),
      "topics" : []
    } );

    groups.push( {
      "priority" : "routine",
      "priorityColor" : "green",
      "useHTMLcolor" : "#9AD506",
      "priorityColorNrs" : [ 1 ],
      "content" : i18n.t("No deviations detected"),
      "topics" : []
    } );

    groups.push( {
      "priority" : "urgent",
      "priorityColor" : "yellow",
      "useHTMLcolor" : "#ffdd6d",
      "priorityColorNrs" : [ 2 ],
      "content" : i18n.t("Moderate deviations"),
      "topics" : []
    } );

    groups.push( {
      "priority" : "stat",
      "priorityColor" : "orange",
      "useHTMLcolor" : "#F46F21",
      "priorityColorNrs" : [ 3, 4 ],
      "content" : i18n.t("Significant deviations"),
      "topics" : []
    } );


    for( var j in groups ){
      groups[ j ].topics = [];
      for( var ii in matrixItems ){
        let matrixItemPriorityNr = matrixItems[ ii ].priorityColorNr;

        let priorityFound = false;

        for( var j2 in groups[ j ].priorityColorNrs ){
          if( groups[ j ].priorityColorNrs[ j2 ] === matrixItemPriorityNr ){
            priorityFound = true;
          }
        }

        if( priorityFound ){
          groups[ j ].topics.push( matrixItems[ ii ] );
        }
      }
    }

    return groups;
  }


}


export default ResultParser;